import { graphql } from 'gatsby';
import React from 'react';

import { ComputedRouteDetailsQuery } from '../../../../graphql-types';
import { TPageProps } from '../../../page-props';
import ComputedRouteDetailsPage from '../../../templates/computed-route-details';

export default (props: TPageProps<ComputedRouteDetailsQuery>) => (
  <ComputedRouteDetailsPage {...props} />
);

export const query = graphql`
  query ComputedRouteDetails($lang: String) {
    prismicHome(lang: { eq: $lang }) {
      _previewable
      data {
        description {
          text
        }
      }
    }
  }
`;
